import { render, staticRenderFns } from "./EXCMRegionUserDataCreateModal.vue?vue&type=template&id=016133a8&"
import script from "./EXCMRegionUserDataCreateModal.vue?vue&type=script&lang=js&"
export * from "./EXCMRegionUserDataCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports